module.exports = __webpack_public_path__ + "img/GreekTechRam3_ua.9acae50c.webp";